<ng-container *transloco="let t">

    <div class="px-4 md:px-16 py-2 md:py-6">
        <div class="flex flex-col">
            <!-- Desktop-Kopf: Überschrift links, Standortwahl rechts auf gleicher Ebene -->
            <div class="hidden md:flex md:flex-row md:items-start md:justify-between md:gap-8">
                <div class="flex flex-col">
                    <div class="flex flex-row md:ml-4 lg:ml-8">
                        <hr class="bg-primary w-24 h-0.5">
                        <!-- Pre Title-->
                        <p class="mt-5 ml-5 text-primary font-semibold">{{t(pretitle)}}</p>
                    </div>
                    <div class="mt-2 md:ml-8 font-medium text-3xl">{{t(title)}}</div>
                </div>
                <div class="flex flex-col md:mr-4 lg:mr-8">
                    <div class="flex flex-row items-center">
                        <mat-icon svgIcon="heroicons_outline:location-marker"></mat-icon>
                        <div class="ml-2 font-bold text-md md:text-xl">{{t('booking-select-location')}}</div>
                    </div>
                    <mat-form-field class="fuse-mat-no-subscript w-full sm:w-72 mt-2">
                        <input matInput #locationInputDesktop
                               [value]="selectedLocation?.name"
                               [matAutocomplete]="locationAutoDesktop"
                               (focus)="onLocationFocus(locationInputDesktop)"
                               (input)="onLocationInput($event)">
                    </mat-form-field>
                    <mat-autocomplete #locationAutoDesktop="matAutocomplete"
                                       (optionSelected)="onLocationOptionSelected($event.option.value, locationInputDesktop)">
                        <mat-option *ngFor="let location of filteredLocations;" [value]="location">{{location?.name}}</mat-option>
                    </mat-autocomplete>

                    <!--Öffnungszeiten kompakt in einer Zeile-->
                    <div class="flex flex-row items-center mt-2 text-secondary">
                        <mat-icon class="icon-size-5" svgIcon="heroicons_outline:clock"></mat-icon>
                        <div class="ml-2 text-md">{{t('booking-open-times')}}: {{formatOpeningHours(selectedLocation)}}</div>
                    </div>

                    <!--Standort-Hinweis nur zeigen, wenn es einen gibt-->
                    <div class="flex flex-row items-center mt-2" *ngIf="selectedLocation?.displayMessage">
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:annotation'"></mat-icon>
                        <div class="ml-2 font-bold text-md">{{selectedLocation?.displayMessage}}</div>
                    </div>
                </div>
            </div>

            <!-- Mobil: Standortwahl & Titelzeile stehen über den Ansichten und bleiben beim Umschalten sichtbar -->
            <div class="flex flex-col mt-2" *ngIf="mobile">
                <mat-form-field class="fuse-mat-no-subscript w-full mt-2">
                    <input matInput #locationInputMobile
                           [value]="selectedLocation?.name"
                           [matAutocomplete]="locationAutoMobile"
                           (focus)="onLocationFocus(locationInputMobile)"
                           (input)="onLocationInput($event)">
                </mat-form-field>
                <mat-autocomplete #locationAutoMobile="matAutocomplete"
                                   (optionSelected)="onLocationOptionSelected($event.option.value, locationInputMobile)">
                    <mat-option *ngFor="let location of filteredLocations;" [value]="location">{{location?.name}}</mat-option>
                </mat-autocomplete>

                <!--Öffnungszeiten kompakt in einer Zeile-->
                <div class="flex flex-row items-center mt-3 text-secondary">
                    <mat-icon class="icon-size-5" svgIcon="heroicons_outline:clock"></mat-icon>
                    <div class="ml-2 text-md">{{t('booking-open-times')}}: {{formatOpeningHours(selectedLocation)}}</div>
                </div>

                <!--Standort-Hinweis nur zeigen, wenn es einen gibt-->
                <div class="flex flex-row items-center mt-2" *ngIf="selectedLocation?.displayMessage">
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:annotation'"></mat-icon>
                    <div class="ml-2 font-bold text-md">{{selectedLocation?.displayMessage}}</div>
                </div>

                <!--Titelzeile: Titel links, Ansicht-Umschalter (nur Icons) und Sortier-Button rechts-->
                <div class="flex flex-row items-center justify-between gap-2 mt-4">
                    <div class="font-medium text-2xl min-w-0 whitespace-nowrap">{{t('header-title-short')}}</div>
                    <div class="flex flex-row items-center flex-none">
                        <mat-button-toggle-group aria-label="layoutStyle" [value]="mobileDisplay"
                            (change)="switchView($event)">
                            <mat-button-toggle value="list" class="bg-primary text-black"
                                [attr.aria-label]="t('button-list')">
                                <mat-icon [svgIcon]="'heroicons_outline:view-list'" class="text-black"></mat-icon>
                            </mat-button-toggle>
                            <mat-button-toggle value="layout" class="bg-primary text-black"
                                [attr.aria-label]="t('button-layout')">
                                <mat-icon [svgIcon]="'heroicons_outline:view-grid'" class="text-black"></mat-icon>
                            </mat-button-toggle>
                        </mat-button-toggle-group>
                        <button mat-icon-button (click)="showSort = !showSort" [matTooltip]="t('sort-by-title')">
                            <mat-icon [svgIcon]="'feather:filter'"></mat-icon>
                        </button>
                    </div>
                </div>
                <mat-form-field class="fuse-mat-no-subscript w-full mb-2" *ngIf="showSort">
                    <mat-select [value]="'-'" (selectionChange)="filterByCategory($event)"
                                [placeholder]="t('sort-by-title')">
                        <mat-option [value]="''">-</mat-option>
                        <ng-container *ngFor="let category of sortCategories; trackBy: trackByFn">
                            <mat-option [value]="category.field">{{
                                    t(category.i18nKey)}}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
                <hr class="bg-primary h-0.5">
            </div>

            <div class="flex flex-row mt-2 md:mt-8">

                <!---Floor plan-->
                <div class="basis-full sm:basis-full md:basis-1/2 w-full h-1/2"
                    *ngIf="!mobile || mobile && mobileDisplay === 'layout'">
                    <div #buildingPlanImg class="p-8 sm:w-auto md:w-auto lg:w-full">
                    </div>
                </div>

                <!---List-->
                <div class="basis-full sm:basis-full md:basis-1/2 lg:basis-1/2 mr-0 sm:mr-0 md:mr-4 lg:mr-8 "
                    *ngIf="!mobile || mobile && mobileDisplay === 'list'" [ngClass]="{'lag-border-bottom': !loading && listUnits.length <= 0}">
                    <div class="flex flex-col">

                        <!--- ###### HEADER START (nur Desktop — Standortwahl steht jetzt oben neben der Überschrift) ######-->
                        <ng-container *ngIf="!mobile">
                            <!--Titel + dezenter Sortier-Button-->
                            <div class="flex flex-row items-center justify-between mt-2">
                                <div class="font-medium text-2xl">{{t('header-title')}}</div>
                                <button mat-icon-button (click)="showSort = !showSort" [matTooltip]="t('sort-by-title')">
                                    <mat-icon [svgIcon]="'feather:filter'"></mat-icon>
                                </button>
                            </div>
                            <mat-form-field class="fuse-mat-no-subscript w-full sm:w-72 mb-2" *ngIf="showSort">
                                <mat-select [value]="'-'" (selectionChange)="filterByCategory($event)"
                                            [placeholder]="t('sort-by-title')">
                                    <mat-option [value]="''">-</mat-option>
                                    <ng-container *ngFor="let category of sortCategories; trackBy: trackByFn">
                                        <mat-option [value]="category.field">{{
                                                t(category.i18nKey)}}</mat-option>
                                    </ng-container>
                                </mat-select>
                            </mat-form-field>
                            <hr class="bg-primary h-0.5">
                        </ng-container>
                        <!--- ###### HEADER END ######-->

                        <!--List-->
                        <div class="pb:0 sm:pb-2 md:pb-2 lg:pb-0">

                            <!-- Kacheln für Mobil & Desktop (Details immer sichtbar);
                                 am Desktop scrollt die Liste neben dem Gebäudeplan -->
                            <div class="flex flex-col gap-3 pb-2 md:max-h-[140vh] md:overflow-y-auto md:pr-2 md:mt-2"
                                 *ngIf="listUnits.length > 0">
                                <div class="bg-card shadow p-3 md:px-6 md:py-4 flex flex-col md:flex-row md:items-center md:gap-6"
                                     [attr.id]="'unit-card-' + unit?._id"
                                     [ngClass]="{'bg-hover': unit?._id === highlightItem?._id, 'list-cursor': !mobile}"
                                     *ngFor="let unit of listUnits;"
                                     (mouseenter)="highlightUnit(unit)" (mouseleave)="unhighlightUnit(unit)">
                                    <!-- Linker Block: am Desktop zwei Zeilen (Name/Chip/Fläche, darunter Maße) -->
                                    <div class="flex flex-col min-w-0 md:flex-1 md:gap-1">
                                        <div class="flex flex-row items-center gap-x-2 md:gap-x-3">
                                            <div class="font-medium text-xl whitespace-nowrap">{{unit?.name}}</div>
                                            <ng-container *ngIf="unit?.additionalInfo">
                                                <mat-icon class="icon-size-2 flex-none" [svgIcon]="'heroicons_solid:information-circle'"
                                                          [matTooltip]="unit?.additionalInfo" *ngIf="!mobile; else unitInfo"></mat-icon>
                                                <ng-template #unitInfo>
                                                    <mat-icon class="icon-size-2 flex-none" [svgIcon]="'heroicons_solid:information-circle'"
                                                              (click)="openInfoDialog(unit?.additionalInfo)"></mat-icon>
                                                </ng-template>
                                            </ng-container>
                                            <!-- Beschreibungs-Chip am Desktop in der ersten Zeile, mittig ausgerichtet -->
                                            <div class="hidden md:block bg-gray-700 text-sm px-2 py-0.5 whitespace-nowrap"
                                                 *ngIf="unit?.description">{{unit?.description}}</div>
                                            <div class="ml-auto md:ml-0 text-primary font-medium whitespace-nowrap">{{t('units-square-meter', {number:
                                                unit.squareMeter?.toString()?.replace('.',',')})}}</div>
                                        </div>

                                        <!-- Beschreibungs-Chip mobil auf eigener Zeile -->
                                        <div class="self-start bg-gray-700 text-sm px-2 py-0.5 mt-1 md:hidden"
                                             *ngIf="unit?.description">{{unit?.description}}</div>
                                        <!-- Maße: zweite Zeile, volle Breite des linken Blocks (kein Zusammenquetschen mehr) -->
                                        <div class="text-md text-secondary mt-1 md:mt-0">
                                            {{unit.length?.toString()?.replace('.',',')}} × {{unit.width?.toString()?.replace('.',',')}} × {{unit.height?.toString()?.replace('.',',')}} m (L × B × H)<ng-container
                                                *ngIf="unit.doorClearance"> · {{t('quick-book-unit-door-clearance')}}: {{unit.doorClearance}}</ng-container>
                                        </div>
                                    </div>

                                    <div class="flex flex-row items-center justify-between gap-2 mt-2 md:mt-0 md:flex-none md:gap-4">
                                        <div class="text-md min-w-0 md:whitespace-nowrap">{{t('booking-units-price-per-month',
                                            {price: unit?.minPrice * 1.2 | currency:'EUR'})}}</div>
                                        <button mat-flat-button (click)="startBooking(unit)"
                                                class="bg-primary text-black flex-none">{{t('quick-book-button')}}
                                        </button>
                                    </div>
                                </div>
                            </div>


                            <div *ngIf="loading">
                                <div class="flex flex-col">
                                    <div class="flex flex-row justify-center">
                                        <video style="pointer-events: none;" src="assets/videos/lag_not_found_dark.mp4" loop autoplay muted webkit-playsinline playsinline width="200" height="200" (click)="doNothing()"></video>
                                    </div>
                                    <div class="flex flex-row justify-center">
                                        <div class="flex flex-col">
                                            <div class="font-bold text-center text-2xl">
                                                {{t('loading')}}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div *ngIf="!loading && listUnits.length <= 0">
                                <div class="flex flex-col">
                                    <div class="flex flex-row justify-center">
                                        <video style="pointer-events: none;" src="assets/videos/lag_not_found_dark.mp4" loop autoplay muted webkit-playsinline playsinline  width="200" height="200" (click)="doNothing()"></video>
                                    </div>
                                    <div class="flex flex-row justify-center">
                                        <div class="flex flex-col">
                                            <div class="font-bold text-center text-2xl">
                                                {{t('booking-no-free-units-title')}}
                                            </div>
                                            <div class="font-bold text-md text-center">
                                                {{t('booking-no-free-units-subtitle')}}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
